import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import React from "react";
import { ShowProps } from "react-admin";
import SubcontractorTimesheetsTable from "../subcontractorTimesheets/components/SubcontractorTimesheetsTable";

const Timesheet = (props: ShowProps) => {
  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Timesheet</Typography>
      </Grid>
      <Grid item xs={12}>
        <SubcontractorTimesheetsTable
          subcontractorId={Number(props.id)}
          isFixedHeight
        />
      </Grid>
    </SanitizedGrid>
  );
};

export default Timesheet;
